import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { EquipmentViewModule } from "src/app/app/equipment/equipment-view/equipment-view.module";
import { InvitationViewModule } from "src/app/app/invitation/invitation-view/invitation-view.module";
import { OrderDetailsViewModule } from "src/app/app/market/order-details-view/order-details-view.module";
import { OrderViewModule } from "src/app/app/market/order-view/order-view.module";
import { LoadingStiModule } from "../../../_component/loading-sti/loading-sti.module";
import { PipesModule } from "../../../_pipes/pipes.module";
import { BookingViewModule } from "../../booking/booking-view/booking-view.module";
import { BuildingFloorViewModule } from "../../building/building-floor-view/building-floor-view.module";
import { BuildingViewModule } from "../../building/building-view/building-view.module";
import { CompanyFloorViewModule } from "../../company/company-floor-view/company-floor-view.module";
import { CompanyViewModule } from "../../company/company-view/company-view.module";
import { CompanyGroupViewModule } from "../../company/group/company-group-view/company-group-view.module";
import { RentalViewModule } from "../../rental/rental-view/rental-view.module";
import { ReportConfigUserViewModule } from "../../report/report-config/report-config-user-view/report-config-user-view.module";
import { ReportConfigViewModule } from "../../report/report-config/report-config-view/report-config-view.module";
import { ReportTaskViewModule } from "../../report/report-task-view/report-task-view.module";
import { ReportViewModule } from "../../report/report-view/report-view.module";
import { UserViewModule } from "../../users/user-view/user-view.module";
import { ModalSelectDropdownModule } from '../modal-select-dropdown/modal-select-dropdown.module';
import { NoResultModule } from "../no-result/no-result.module";
import { SelectDropdownModule } from './../select-dropdown/select-dropdown.module';
import { PaginationClientSideComponent } from "./pagination-client-side.component";
import { CompanyAccessViewModule } from "../../company/company-access/company-access-view/company-access-view.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        TranslateModule,
        RouterModule,
        BuildingViewModule,
        CompanyViewModule,
        ReportTaskViewModule,
        UserViewModule,
        InvitationViewModule,
        OrderDetailsViewModule,
        ReportConfigViewModule,
        ReportConfigUserViewModule,
        ReportViewModule,
        BuildingFloorViewModule,
        CompanyFloorViewModule,
        EquipmentViewModule,
        BookingViewModule,
        OrderViewModule,
        PipesModule,
        NoResultModule,
        LoadingStiModule,
        SelectDropdownModule,
        ModalSelectDropdownModule,
        CompanyGroupViewModule,
        RentalViewModule,
        CompanyAccessViewModule,
    ],
    declarations: [PaginationClientSideComponent],
    exports: [PaginationClientSideComponent]
})
export class PaginationClientSideModule {}
